import { Link, useLocation } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function NotFound() {
  const location = useLocation();
  useDocumentTitle("页面不存在 - 鸭王在线观看");

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500/15 text-3xl text-primary-300">
        <i className="ri-emotion-sad-line"></i>
      </span>
      <h1 className="mt-6 font-heading text-5xl font-black text-foreground-950 md:text-7xl">404</h1>
      <p className="mt-3 text-base text-foreground-800 md:text-lg">你访问的页面不存在</p>
      <p className="mt-1 font-mono text-sm text-foreground-600">{location.pathname}</p>
      <div className="mt-6 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-semibold text-background-950 transition-colors hover:bg-accent-400"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300/60 px-6 py-3 text-sm font-medium text-foreground-900 transition-colors hover:border-accent-500 hover:text-accent-500"
        >
          搜索影片
        </Link>
      </div>
    </div>
  );
}